export default __webpack_public_path__ + "maps-examples-multiple-shapes-960-b068b2d09537aed927e66a7c42a8b0fd.webp";